<template>
  <div class="changelog-view">
    <div v-if="loading" class="changelog-message">
      Ładowanie changelogu...
    </div>
    <div v-else-if="error" class="changelog-message changelog-error">
      Nie udało się pobrać changelogu.
    </div>
    <pre v-else class="changelog-content">{{ content }}</pre>
  </div>
</template>

<script>
import ChangelogApi from '../api/changelog'
import setTitle from '../mixins/set_title'

export default {
  name: 'changelog',
  mixins: [setTitle],
  data: function () {
    return {
      headerTitle: 'Changelog',
      headerSubtitle: '',
      content: '',
      loading: true,
      error: false
    }
  },
  created () {
    ChangelogApi.getChangelog()
      .then(response => {
        this.content = response.data.content
        this.loading = false
      })
      .catch(error => {
        console.log(error.message)
        this.error = true
        this.loading = false
      })
  },
  mounted () {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
    this.$store.dispatch('header/setHeader', {
      title: this.$t(this.headerTitle),
      subtitle: this.$t(this.headerSubtitle),
      capitalizeSubtitle: false
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/stylesheets/vars';

.changelog-view {
  margin: 0 auto;
  padding: 32px 24px;
}

.changelog-content {
  margin-top: 24px;
  padding: 24px;
  border: 1px solid $pcg-lightest-gray;
  border-radius: 4px;
  background: $pcg-white;
  color: $pcg-the-darkest-gray;
  font-family: inherit;
  font-size: 16px;
  line-height: 1.6;
  white-space: pre-wrap;
}

.changelog-message {
  margin-top: 24px;
}

.changelog-error {
  color: $pcg-red;
}
</style>

<style lang="scss" scoped>
@import "../assets/stylesheets/vars-contrast";
.contrast {
  h1 {
    color: $main-color;
  }
  h2 {
    color: $main-active-color;
  }
  h3 {
    color: $main-active-color;
  }
  .declaration-text {
    color: $pcg-the-darkest-gray;
  }
}
</style>
